import { usePage } from "@inertiajs/react"
import type { PageProps } from "@/types/inertia"

// App-wide flash renderer, mounted by AppShell and AdminShell above the page
// content. Auth pages (AuthShell) render their own flash inline.
export function FlashMessages() {
  const { props } = usePage<PageProps>()
  const notice = props.flash?.notice
  const alert = props.flash?.alert

  if (!notice && !alert) return null

  return (
    <div className="mb-6 space-y-2">
      {notice && <p className="text-sm text-accent">{notice}</p>}
      {alert && <p className="text-sm text-danger-display">{alert}</p>}
    </div>
  )
}
